module.exports = __webpack_public_path__ + "dad52a80f50133de45cb882d3c29cf04.svg";